import { z } from "zod/v4";
import type { TelegramDocument } from "../types/document.ts";

const PointSchema = z.tuple([z.number(), z.number()]);

const DrawObjectSchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("pencil"),
    points: z.array(PointSchema),
    color: z.string(),
    width: z.number(),
  }),
  z.object({
    type: z.literal("line"),
    from: PointSchema,
    to: PointSchema,
    color: z.string(),
    width: z.number(),
  }),
  z.object({
    type: z.literal("rect"),
    origin: PointSchema,
    size: PointSchema,
    color: z.string(),
    width: z.number(),
    fill: z.string().optional(),
  }),
  z.object({
    type: z.literal("ellipse"),
    center: PointSchema,
    radii: PointSchema,
    color: z.string(),
    width: z.number(),
    fill: z.string().optional(),
  }),
  z.object({
    type: z.literal("emoji"),
    position: PointSchema,
    emoji: z.string(),
    size: z.number(),
  }),
]);

export const TelegramDocumentSchema = z.object({
  version: z.literal(1),
  text: z.object({
    html: z.string(),
    style: z.object({
      fontFamily: z.string(),
      fontSize: z.number(),
      color: z.string(),
      lineHeight: z.number(),
    }),
  }),
  canvas: z.object({
    width: z.number(),
    height: z.number(),
  }),
  objects: z.array(DrawObjectSchema),
}) satisfies z.ZodType<TelegramDocument>;
